import React from 'react';
import {validateImage} from '../../../Util/validators';
import {Box, Button} from '@mui/material';

type Props = {
  thumbnail?: any;
  setThumbnail: Function;
  isValid: boolean;
  fileType: 'img' | 'pdf';
  imageUrl?: string;
};

export default function DropZone(props: Props) {
  const {thumbnail, setThumbnail, isValid, fileType, imageUrl} = props;
  const handleThumbnailChange = e => {
    const file = e.target.files[0];
    if ((fileType === 'img' && validateImage(file)) || fileType === 'pdf') {
      const reader = new FileReader();
      reader.onload = () => {
        setThumbnail(reader.result, file.name);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleThumbnailDrop = event => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];

    if ((fileType === 'img' && validateImage(file)) || fileType === 'pdf') {
      const reader = new FileReader();
      reader.onload = () => {
        setThumbnail(reader.result, file.name);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleThumbnailDragOver = event => {
    event.preventDefault();
  };
  const handleRemove = () => setThumbnail(null);

  return (
    <div>
      {thumbnail || imageUrl ? (
        <Box style={styles.fileContainer}>
          <img
            src={thumbnail || imageUrl}
            alt="File"
            style={{maxWidth: '100px'}}
          />
          <Button onClick={handleRemove} style={styles.removeButton}>
            Remove
          </Button>
        </Box>
      ) : (
        <Box
          onDrop={handleThumbnailDrop}
          onDragOver={handleThumbnailDragOver}
          style={{
            ...styles.dropZoneContainer,
            borderColor: isValid ? '#ccc' : 'red',
          }}>
          <label
            htmlFor={`thumbnail-upload-${fileType}`}
            style={styles.dropZoneLabel as React.CSSProperties}>
            <span>
              Drop files here or <span style={{color: 'blue'}}>Browse</span>
            </span>
          </label>
          <input
            id={`thumbnail-upload-${fileType}`}
            type="file"
            accept={fileType === 'img' ? 'image/*' : 'application/pdf'}
            onChange={handleThumbnailChange}
            style={styles.imageInput}
          />
        </Box>
      )}
    </div>
  );
}

const styles = {
  fileContainer: {display: 'flex', alignItems: 'center'},
  removeButton: {marginLeft: 10},
  dropZoneContainer: {
    height: 75,
    border: '2px dashed',
    borderRadius: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dropZoneLabel: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageInput: {display: 'none'},
};
